import { AmplitudeContext } from 'contexts/AmplitudeContext';
import { useContext } from 'react';

export const useAmplitude = () => {
  const { logEvent, setUserId, setDeviceId } = useContext(AmplitudeContext);

  return { logEvent, setUserId, setDeviceId };
};
